import styled, {
  CSSProperties,
  FlattenInterpolation,
  FlattenSimpleInterpolation,
  css,
} from "styled-components";
import {
  placementMap,
  getOffsetByPlacement,
  PlacementType,
  getPlacement,
} from "../../constants";

export const DropdownWrapper = styled.div<{
  showArrow: string;
  arrowRight: string;
  active: string;
  wrapperBackground: string;
  wrapperActiveBackground: string;
  wrapperActiveCSS: FlattenSimpleInterpolation;
  customCSS: FlattenSimpleInterpolation;
}>`
  position: relative;
  height: max-content;
  display: flex;
  align-items: center;
  background: ${(p) =>
    p.active ? p.wrapperActiveBackground : p.wrapperBackground};
  ${(p) =>
    p.showArrow &&
    css`
      > svg:last-child {
        position: absolute;
        right: ${(p) => p.arrowRight};
        transform: ${(p) => p.active && "rotate(180deg)"};
        transition: all 0.2s ease-in-out;
      }
    `};
  ${(p) => p.active && p.wrapperActiveCSS};
  ${(p) => p.customCSS};
`;
export const DropdownContent = styled.div<{
  placement: PlacementType;
  offsetX: string;
  offsetY: string;
  fixed: boolean;
}>`
  position: ${(p) => (p.fixed ? "fixed" : "absolute")};
  width: ${(p) => p.width};
  min-width: max-content;
  background: var(--task-eva-dropdown-content-bg);
  border: 1px solid var(--task-eva-dropdown-content-border);
  box-shadow: var(--task-eva-dropdown-content-shadow);
  z-index: 20001;
  ${(p) =>
    !p.open &&
    css`
      opacity: 0;
      transition: opacity 0.5s;
      pointer-events: none;
    `}
  ${({
    placement,
    basicLeft,
    basicTop,
    basicRight,
    basicBottom,
    dropdownContentWidth,
    fixed,
    offsetX,
    offsetY,
  }) => {
    return fixed
      ? getPlacement({
          placement,
          basicBottom,
          basicLeft,
          basicRight,
          basicTop,
          dropdownContentWidth,
        })
      : [
          placementMap.get(placement),
          getOffsetByPlacement(placement, offsetX, offsetY),
        ];
  }};
  ${(p) => p.dropdownContentCSS};
`;
